// extracted by mini-css-extract-plugin
export default {"cta":"sG-z","disabled":"tG-z"};